document.addEventListener('DOMContentLoaded', () => {
  const setAccordionItemState = (item, isActive) => {
    const header = item.querySelector('.accordion-header');
    const panelId = header?.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;

    item.classList.toggle('active', isActive);
    header?.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    panel?.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    panel?.toggleAttribute('inert', !isActive);
  };

  document.querySelectorAll('.premium-accordion').forEach((accordion) => {
    accordion.querySelectorAll('.accordion-item').forEach((item) => {
      setAccordionItemState(item, item.classList.contains('active'));
    });
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const header = event.target.closest('.premium-accordion .accordion-header');
    if (!header) return;

    const accordion = header.closest('.premium-accordion');
    const item = header.closest('.accordion-item');
    if (!accordion || !item) return;

    const isActive = item.classList.contains('active');
    accordion.querySelectorAll('.accordion-item').forEach((accordionItem) => {
      setAccordionItemState(accordionItem, false);
    });

    if (!isActive) setAccordionItemState(item, true);
  });
});
